import React from "react";
import image from "./logo-diario-24-horas.png";

export const Logo = () => (
  <img src={image} alt="Diário 24 Horas" />
);
